import BlockTwoBlocksBanner from './twoBlocksBanner'

export default BlockTwoBlocksBanner
